export default __webpack_public_path__ + "static/media/SAS0120.34I-32498_-18319_0.53b0e8f0.jpg";